/**
 * Utility functions for working with post nodes..
 *
 * Copyright (c) 2018 Kier Dugan.
 */


 // ============================================================================
 const extractTags = (posts) => {
   // For a given collection of posts, collect and count all the tags across all
   // posts.  The return value is a mapping of tag name to its number of
   // occurrences.
   return posts.reduce(
     (allTags, post) => {
       const { frontmatter: { tags: postTags } } = post

       if (postTags) {
         postTags.forEach(tag => allTags[tag] = 1 + (allTags[tag] || 0))
       }

       return allTags
     }, {})
 }


// =============================================================================
module.exports = extractTags
